import React, { useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import renderHTML from 'react-render-html'
import { fetchEthics } from '../../../redux/action/ethics/Ethics'
import MainLoading from '../../../utils/MainLoading'
import HomeMainTitle from '../../homeTitle/HomeMainTitle'
import Wrapper from '../../homeWrapper/Wrapper'

const Ethics = () => {
    const dispatch = useDispatch()
    const ethics_info = useSelector(state => state.ethics_info)

    useEffect(() => {
        if(!ethics_info.ethics_info.id) {
            dispatch(fetchEthics())
        }
    }, [])

    return (
        <Wrapper>
            {ethics_info.loading ?
                <MainLoading />
            :
                <Container className="mt-5">
                    {ethics_info.ethics_info.title ?
                        <>
                            <Helmet>
                                <title>{ethics_info.ethics_info.title} - نمایشگاه مجازی</title>
                            </Helmet>
                            <HomeMainTitle> {ethics_info.ethics_info.title} </HomeMainTitle>
                            <div className='py-3'>
                                {ethics_info.ethics_info.description && renderHTML(ethics_info.ethics_info.description)}
                            </div>
                        </>
                    :
                        <HomeMainTitle> منشور اخلاقــی </HomeMainTitle>
                    }
                </Container>
            }
        </Wrapper>
    )
}

export default Ethics
